/* eslint-disable react/no-unused-prop-types */
import { FC } from 'react';
import { Currency, UnitOfMeasure } from '../../../../Generated/Raven-Demeter';
import { IChartDataSeries } from '../../../Components/Charts/ChartDefinitions';
import ChartWrapper from '../../../Components/Charts/ChartWrapper/ChartWrapper';
import MarketIndicatorUserChartRaw from '../../../Components/Charts/MarketIndicators/MarketIndicatorUserChartRaw';
import styles from './CalendarSpreadCalculator.module.scss';

interface ICalendarSpreadCalculatorSeasonalChart {
    title: string;
    dataSourceTag: string[];
    currency: Currency;
    unitOfMeasure: UnitOfMeasure;
    linesSeries: IChartDataSeries[];
    isLoading: boolean;
}

const CalendarSpreadCalculatorSeasonalChart: FC<ICalendarSpreadCalculatorSeasonalChart> = (props: ICalendarSpreadCalculatorSeasonalChart) => (
    <div className={styles.calendar_spread_calculator_chart}>
        <ChartWrapper
            name="CalendarSpreadCalculatorChart"
            title={props.title}
            dataSourceTag={props.dataSourceTag}
            isLoading={props.isLoading}
            track={{ eventCategory: 'CalendarSpreadCalculator', eventAction: 'SeasonalChart' }}
        >
            <MarketIndicatorUserChartRaw lineSeries={props.linesSeries} currencies={[props.currency]} unitOfMeasures={[props.unitOfMeasure]} />
        </ChartWrapper>
    </div>
);

export default CalendarSpreadCalculatorSeasonalChart;
